import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SimpleToggle, Typography } from '@dev/ee-components';
import styled from 'styled-components';

import { useGetSettingsInfo } from '@/components/CampaignCreator/SettingsAndTracking/hooks/useGetStep3Info';
import { ShowToast } from '@/store/toast/actions';
import { debounce } from '@/services/tools/debounce';
import { ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { useAccountTrusted } from '../../../../../hooks/useAccountTrusted';
import { ToggleWrapper } from '../../../../../styled';

import { useCampaignScreensPathsChecker } from '../../../../../hooks/useCampaignScreensPathsChecker';

const DescriptionWrapper = styled.div`
    margin-left: 60px;
`;

export const TrackOpens = (): JSX.Element => {
    const { t } = useTranslation();
    const isAccountTrusted = useAccountTrusted();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { trackOpens } = useGetSettingsInfo();
    const [toggleTrackOpens, setToggleTrackOpens] = useState(trackOpens);

    const changeToggleHandler = (ev): void => {
        if (!isAccountTrusted) {
            setToggleTrackOpens(false);
            debounce((): void => {
                setToggleTrackOpens(true);
                dispatch(
                    ShowToast({
                        severity: 'error',
                        message: t('turnofftrackingerror'),
                        duration: 7000,
                        width: '1010px',
                    })
                );
            }, 500);
            return;
        }
        setToggleTrackOpens(ev.target.checked);
        const modifyMap = new Map<string, any>();
        modifyMap.set('TrackingOptions.TrackOpens', ev.target.checked);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    return (
        <>
            <ToggleWrapper>
                <SimpleToggle
                    id="track-opens-toggle"
                    value="trackopens"
                    checked={toggleTrackOpens}
                    disabled={isDetailsScreen}
                    onChange={changeToggleHandler}
                />
                <Typography variant="h3">{t('trackopens')}</Typography>
            </ToggleWrapper>
            <DescriptionWrapper>
                <Typography variant="body1">{t('trackopens_desc')}</Typography>
            </DescriptionWrapper>
        </>
    );
};
